import React, { Component } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import { BASE_IMAGES_URL, ACCESS_FILES_API_KEY } from "Constants";
import LocaleStrings from "../../../../../../languages";

class TableContentTopSpeaker extends Component {
  // Create table body
  renderSpeakerTopspkrTablelist() {
    // var items=_.map( this.props.websitePages.resource, values => <TablebodyItem key={values.id} values={values}/>);
    var items = _.map(this.props.speakerTopspkrTablelist, (values) => {
      var imagePath = "../../style/images/custom-icons/user_2.png";
      var errorPath = "../../style/images/custom-icons/user_2.png";
      //var imagePath = `${BASE_IMAGES_URL}/${values.profilethumbimage}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}`;
      var imagePath = `${BASE_IMAGES_URL}/${values.profileimage}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}&download=true`;
      return (
        <tr key={values.name}>
          <td>
            <div className="row">
              <div className="col-md-12 col-lg-12 d-flex">
                <div className="analytics-table-td">
                  <img
                    className="rounded-circle analytics-table-cust-img"
                    alt={values.name}
                    src={imagePath}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = errorPath;
                    }}
                  />{" "}
                  {values.name.length > 80
                    ? values.name.substring(0, 80) + "..."
                    : values.name}
                </div>
              </div>
            </div>
          </td>
          <td>
            <div className="row">
              <div className="col-md-12 col-lg-12">
                <div align="center">{values.noofviews}</div>
              </div>
            </div>
          </td>
        </tr>
      );
    });

    return items;
  }

  // Printing the output

  render() {
    return (
      <div className="social-content">
        <div className="tableHeaderSection">
          <p className="analytics-chart-header">
            {LocaleStrings.analytics_speakers_chart_1st_header}
          </p>
          <p className="analytics-chart-subheader">
            ({LocaleStrings.analytics_speakers_chart_1st_subheader})
          </p>
        </div>
        <table className="table">
          <thead className="analyticsTable">
            <tr>
              <th>
                {LocaleStrings.analytics_speakersinsights_table_thead_text5}
              </th>
              <th className="text-center">
                {LocaleStrings.analytics_speakersinsights_table_thead_text6}
              </th>
            </tr>
          </thead>
          <tbody className="tbody-background">
            {this.renderSpeakerTopspkrTablelist()}
          </tbody>
        </table>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    speakerTopspkrTablelist: state.speakerTopspkrTablelist,
  };
}

export default connect(mapStateToProps)(TableContentTopSpeaker);
